let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6dgfh")).then(() => parcelRequire('gQw6H'));